import React, { useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import ToastNotification from "../../../components/toastNotification";
import { callApiAsync, saveNewSupplier } from "../../../services/apiService";

const validationSchema = yup.object().shape({
  supplierName: yup
    .string()
    .transform((v) => (v ? v.trim() : v))
    .required("Este campo es obligatorio")
    .min(1, "Este campo no puede estar vacío")
});

const AddSupplier = ({
  open,
  close,
  supplierOptions = [],
  setSupplierOptions = () => {}
}) => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
    getValues
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { supplierName: "" }
  });

  const saveSupplier = (data) => {
    callApiAsync(
      () => saveNewSupplier(data),
      (res) => {
        setSupplierOptions();
        handleClose();
      }
    );
  };

  const handleClose = () => {
    reset({ supplierName: "" });
    close();
  };

  const onSubmit = (formData) => {
    const name = (formData?.supplierName || "").trim();

    const exists = supplierOptions.some(
      (s) => (s?.name || "").trim().toLowerCase() === name.toLowerCase()
    );

    if (exists) {
      setToastMessage("Ya existe un proveedor con este nombre.");
      setShowToast(true);
      return;
    }
    const payload = { name };
    saveSupplier(payload);
  };

  return (
    <>
      <ToastNotification
        severity="warn"
        summary={toastMessage}
        detail=""
        showToast={showToast}
        setShowToast={setShowToast}
      />

      <ModalComponent
        open={open}
        title="Agregar Nuevo Proveedor"
        handleClose={handleClose}
        actions={<></>}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <p className="create-label ml-0">Nombre del proveedor:</p>
              <FormTextField
                name="supplierName"
                control={control}
                error={errors.supplierName}
                margin={"0"}
              />
            </Grid>
          </Grid>

          <div className="j-center">
            <LaddaButton
              fontSize={"12px"}
              height={"32px"}
              variant="contained"
              margin={"20px 0"}
              type="submit"
            >
              <p className="button_text">Crear Proveedor</p>
            </LaddaButton>
          </div>
        </form>
      </ModalComponent>
    </>
  );
};

export default AddSupplier;
